import * as types from "../actions/actionTypes";

// The summary the server answers with when the host ends a session, shown on the ended
// page (the session itself is cleared by then). It stays until another session starts.
export default function summaryReducer(state = null, action) {
  switch (action.type) {
    case types.SUMMARY_SET:
      return action.summary || null;

    case types.SUMMARY_CLEAR:
    case types.SESSION_SET_CODE:
      return null;

    default:
      return state;
  }
}
